import { useEffect, useMemo, useState } from "react";
import Alert from "react-bootstrap/Alert";
import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";

const SOCIAL_API_BASE_URL = process.env.REACT_APP_SOCIAL_API_BASE_URL || "";

function toNumber(value) {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
}

function Social({ idToken = "", disabled = false }) {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [refreshNonce, setRefreshNonce] = useState(0);

  useEffect(() => {
    let cancelled = false;

    const loadUsers = async () => {
      if (!idToken) {
        setUsers([]);
        setError("");
        return;
      }

      if (!SOCIAL_API_BASE_URL) {
        setUsers([]);
        setError("Missing REACT_APP_SOCIAL_API_BASE_URL");
        return;
      }

      setLoading(true);
      setError("");
      try {
        const response = await fetch(`${SOCIAL_API_BASE_URL}/users`, {
          headers: {
            Authorization: `Bearer ${idToken}`,
          },
        });
        const body = await response.json();
        console.log(body);
        if (!response.ok) {
          throw new Error(body.error || body.message || "Failed to load users");
        }

        if (!cancelled) {
          setUsers(Array.isArray(body.items) ? body.items : []);
        }
      } catch (err) {
        if (!cancelled) {
          setError(err.message || "Failed to load users");
          setUsers([]);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        } else {
        }
      }
    };

    loadUsers();
    return () => {
      cancelled = true;
    };
  }, [idToken, refreshNonce]);

  const leaderboard = useMemo(() => {
    return [...users]
      .map((user) => ({
        ...user,
        total_balance: toNumber(user.cash_total),
      }))
      .sort((a, b) => b.total_balance - a.total_balance);
  }, [users]);

  const handleRefresh = () => {
    setRefreshNonce((current) => current + 1);
  };

  return (
    <div>
      {error && <Alert variant="warning">{error}</Alert>}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <strong>Leaderboard</strong>
        </div>
        <Button size="sm" onClick={handleRefresh} disabled={disabled || loading || !idToken}>
          {loading ? "Refreshing..." : "Refresh"}
        </Button>
      </div>
      <Table striped bordered hover responsive variant="dark">
        <thead>
          <tr>
            <th>Rank</th>
            <th>Username</th>
            {/* <th>Cash Available</th>
            <th>Cash Reserved</th> */}
            <th>Total Balance</th>
          </tr>
        </thead>
        <tbody>
          {leaderboard.length === 0 ? (
            <tr>
              <td colSpan={6}>
                {loading ? "Loading users..." : "No users available"}
              </td>
            </tr>
          ) : (
            leaderboard.map((user, index) => (
              <tr key={user.user_id || user.username || index}>
                <td>{index + 1}</td>
                <td>{user.username || "-"}</td>
                {/* <td>{user.cash_available ?? "0.00"}</td>
                <td>{user.cash_reserved ?? "0.00"}</td> */}
                <td>{user.cash_total ?? user.total_balance.toFixed(2)}</td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
    </div>
  );
}

export default Social;
